import React from "react";
import Signup from "../templates/Signup";
import { useParams } from "react-router-dom";
import TransitionWrapper from "../atoms/TransitionWrapper";
import UseLandingLoader from "../../hooks/useLandingLoader";

const SignupPage = () => {
  const params = useParams();
  UseLandingLoader();
  return (
    <TransitionWrapper>
      <Signup portal={params.userType} />
    </TransitionWrapper>
  );
};

export default SignupPage;
